import { ButterProductsArr } from "./ButterProducts/ButterProductsArr";
import { CraftProductsArr } from "./CraftProductsArr/CraftProductsArr";
import { FermentedMilkProductsArr } from "./FermentedMilkProductsArr/FermentedMilkProductsArr";
import { MilkProductsArr } from "./MilkProducts/MilkProductsArr";

export const ProductPagesUa = [
    ...MilkProductsArr,
    ...ButterProductsArr,
    ...FermentedMilkProductsArr,
    ...CraftProductsArr
]